<template>

    <div>
        <h5>All Learning Outcomes</h5>

        <div class="card">
            <div class="flex justify-content-between">
                <h6>Search Criteria:</h6>
                <div>
                    <Button v-if="authStore.hasPermission(UserPermission.WRITE_LEARNING_OUTCOME)" label="Add New Learning Outcome" class="mb-2" @click="addLearningOutcome" />
                </div>
            </div>

            <Accordion :activeIndex="0" class="mb-3">
                <AccordionTab header="Use as few or as many as you wish, partial matches are acceptable.">

                    <div class="p-fluid formgrid grid flex flex-wrap">

                        <div class="field col-12 sm:col-6 md:col-3">
                            <base-dropdown
                                v-model="search.no_task"
                                :options="taskNoTask"
                                optionLabel="description"
                                optionValue="code"
                                label="With Tasks"
                                show-clear
                                :filter="false"
                            />
                        </div>

                        <div class="field col-12 sm:col-6 md:col-3">
                            <base-dropdown
                                v-model="search.no_debrief"
                                :options="debriefNoDebrief"
                                optionLabel="description"
                                optionValue="code"
                                label="With Debriefs"
                                show-clear
                                :filter="false"
                            />
                        </div>

                        <div class="field col-12 sm:col-6 md:col-3">
                            <label class="mb-2" for="theme_id">Theme</label>
                            <VueTreeSelect
                                :key="reloadTreeSelect"
                                id="theme_id"
                                class="p-multiselect p-component"
                                v-model="search.theme_id"
                                :options="themes"
                                placeholder="Select a Theme"
                                value-consists-of="ALL"
                                :multiple="false"
                            />
                        </div>

                        <div class="field col-12 sm:col-6 md:col-3">
                            <label class="mb-2" for="source_id">Source</label>
                            <VueTreeSelect
                                :key="reloadTreeSelect"
                                id="source_id"
                                class="p-multiselect p-component"
                                v-model="search.source_id"
                                :options="sources"
                                placeholder="Select a Source"
                                value-consists-of="ALL"
                                :multiple="false"
                            />
                        </div>

<!--                        <div class="field col-12 sm:col-6 md:col-3">-->
<!--                            <label class="mb-2" for="details">Details</label>-->
<!--                            <InputText id="linkUrl" v-model="search.details" />-->
<!--                        </div>-->

                        <div class="col-12 flex justify-content-end">
                            <div class="flex">
                                <Button type="button" icon="pi pi-filter" label="Filter" class="p-button-outlined p-button-success ml-2" @click="applyFilter" />
                                <Button type="button" icon="pi pi-filter-slash" label="Clear" class="p-button-outlined p-button-danger ml-2" @click="clearFilter" />
                            </div>
                        </div>
                    </div>
                </AccordionTab>
            </Accordion>

            <DataTable

                :multiSortMeta="preSort"
                v-model:first="offset"
                :rows="numberOfRows"

                :value="allLearningOutcomes"
                :lazy="true"
                :paginator="true"

                ref="dt"
                dataKey="id"
                :totalRecords="totalRecords"
                :loading="loading"
                @page="onPage($event)"
                @sort="onSort($event)"
                removableSort
                sortMode="multiple"
                responsiveLayout="scroll"
                :rowsPerPageOptions="[5, 10, 20, 50, 100]"
                paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
            >
                <template #empty> No Learning Outcomes available. </template>
                <template #loading> Loading Learning Outcomes. Please wait. </template>
                <Column field="id" header="Id" style="width: 4%"></Column>
                <Column header="Theme" style="width: 5%">
                    <template #body="slotProps">
                        {{slotProps.data?.theme?.name}}
                    </template>
                </Column>
                <Column header="Source" style="width: 5%">
                    <template #body="slotProps">
                        {{slotProps.data?.source?.name}}
                    </template>
                </Column>
                <Column header="Type" style="width: 5%">
                    <template #body="slotProps">
                        <span v-if="parseInt(slotProps.data?.outcome_type) === 1">Local Issue</span>
                        <span v-else-if="parseInt(slotProps.data?.outcome_type) === 2">Service Wide</span>
                        <span v-else-if="parseInt(slotProps.data?.outcome_type) === 3">Notable Practice</span>
                    </template>
                </Column>
                <Column header="Tasks" style="width: 5%">
                    <template #body="slotProps">
                        <Badge v-if="slotProps.data.task?.length === 0" value="0" severity="danger"></Badge>
                        <Badge v-else :value="countTasks(slotProps.data.task)" severity="success"></Badge>
                    </template>
                </Column>
                <Column header="Attachments" style="width: 5%">
                    <template #body="slotProps">
                        {{ slotProps.data?.attachments?.length }}
                    </template>
                </Column>
                <Column header="Completed" style="width: 5%">
                    <template #body="slotProps">
                        <span v-if="parseInt(slotProps.data?.complete) === 1">Complete</span>
                        <span v-else>Not completed</span>
                    </template>
                </Column>
                <Column field="actions" header="ACTIONS" style="width: 5%">
                    <template #body="slotProps">
                        <span class="p-column-title">ACTIONS</span>
                        <Button v-if="authStore.hasPermission(UserPermission.WRITE_LEARNING_OUTCOME)" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-1" @click="editLearningOutcome(slotProps.data.id)" v-tooltip="'Edit Task'" />
                        <!--<Button v-if="authStore.hasPermission(UserPermission.READ_LEARNING_OUTCOME)" icon="pi pi-eye" class="p-button-rounded p-button-info mr-1" @click="editLearningOutcome(slotProps.data.id)" v-tooltip="'View Task'" />-->
                        <Button
                            v-if="authStore.hasPermission(UserPermission.DELETE_LEARNING_OUTCOME)"
                            icon="pi pi-trash"
                            class="p-button-rounded p-button-danger"
                            @click="confirmRequest({ id: slotProps.data.id }, deleteLearningOutcome)"
                            v-tooltip="'Delete Incident'"
                            :disabled="slotProps.data?.task.length > 0"
                        />
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>


    <Dialog v-model:visible="showEditingLearningOutcome" modal
            @hide="closeLearningOutcomePopup"
            :header="createUpdateLearningOutcomePopupTitle" :style="{ width: '100rem' }">

        <CreateUpdateLearningOutcome
            :learning-outcome="editingLearningOutcome"
            :themes="themesVisible"
            :sources="sources"
            :popup-mode="true"
            :saving-debrief="false"
            @close_popup="closeLearningOutcomePopup"
            @reLoadDebrief="onLearningOutcomeSaved"
        />

    </Dialog>

</template>

<script setup>

import { computed, onMounted, ref } from 'vue';
import {
    buildPagination,
    getOrder,
    getPage,
    getPerPage,
    setOrder,
    setPage,
    setPerPage,
} from '@/composables/PaginationComposable';
import { authStore } from '@/store/global-stores';
import { authApi } from '@/utilities/axios';
import hasOwn from 'core-js/internals/has-own-property';
import { UserPermission } from '@/modules/permission/enum';
import { useConfirmRemove } from '@/composables/ConfirmComposable';
import CreateUpdateLearningOutcome from '@/product/ams/components/CreateUpdateLearningOutcome.vue';
import { showToast } from '@/utilities/toast-handler';

const { confirmRequest } = useConfirmRemove();

const pageList = 'learningOutcomeList'
const loading = ref(false)
const totalRecords = ref(0)
const allLearningOutcomes = ref([])

const showEditingLearningOutcome= ref(false)
const editingLearningOutcome = ref(null)

const createUpdateLearningOutcomePopupTitle = ref('')
const themes = ref([])
const themesVisible = ref([])
const sources = ref([])

const reloadTreeSelect = ref(0)

const search = ref({
    no_task: null,
    no_debrief: null,
    theme_id: null,
    source_id: null,
    details: null,
})

const taskNoTask = [
    {
        code: null,
        description: 'All'
    },
    {
        code: 'no_task',
        description: 'Without tasks'
    },
    {
        code: 'with_task',
        description: 'With tasks'
    },
]

const debriefNoDebrief = [
    {
        code: null,
        description: 'All'
    },
    {
        code: 'no_debrief',
        description: 'Without debrief'
    },
    {
        code: 'with_debrief',
        description: 'With debrief'
    },
]

const company_id = computed(() => {
    return authStore.getLoggedUserCompanyId;
});

onMounted(async () => {
    buildPagination(pageList, 0, 10, [{field: "id", order: -1}])
    
    themes.value = await loadThemes(false)        // ALL
    themesVisible.value = await loadThemes(true)  // ONLY visible

    loadSources()
    loadLearningOutcomes()
});

const offset = computed(() => {
    return getPage(pageList) * getPerPage(pageList)
})

const preSort = computed(() => {
    return getOrder(pageList)
})

const numberOfRows = computed(() => {
    return getPerPage(pageList)
})

const onPage = (event) => {
    setPage(pageList, event.page)
    setPerPage(pageList, event.rows)
    loadLearningOutcomes();
};

const onSort = (event) => {
    setOrder(pageList, event.multiSortMeta)
    loadLearningOutcomes();
};

function addLearningOutcome() {
    editingLearningOutcome.value = null
    showEditingLearningOutcome.value = true
    createUpdateLearningOutcomePopupTitle.value = 'Add Learning Outcome'
}

function countTasks(data) {
    let tasks = 0

    console.log('countTasks', data)

    data.forEach((item) => {
        if (item.active !== 0) {
            tasks += 1
        }
    })

    return tasks.toString()

}

function loadLearningOutcomes() {

    loading.value = true

    let page_size = getPerPage(pageList);
    let page = getPage(pageList);

    let params = {
        company_id: company_id.value,

        page_size: page_size,
        page: page + 1,
        paginate: true,
    }

    if (search.value.no_task !== null) {
        params.no_task = search.value.no_task
    }

    if (search.value.no_debrief !== null) {
        params.no_debrief = search.value.no_debrief
    }

    if (search.value.theme_id !== null) {
        params.theme_id = search.value.theme_id
    }

    if (search.value.source_id !== null) {
        params.source_id = search.value.source_id
    }

    if (search.value.details !== null) {
        params.details = search.value.details
    }

    authApi.get(`${process.env.VUE_APP_API_VERSION}/learning-outcome`, {
        params: params,
    }).then((response) => {

        if (response.statusCode === 200) {

            if (hasOwn(response, 'data')) {
                totalRecords.value = response.data.total;

                if (hasOwn(response.data, 'data')) {
                    allLearningOutcomes.value = response.data.data
                }
            }
        }
    }).finally(() => {
        loading.value = false
    })
}

async function loadThemes(onlyVisible = false) {
    const response = await authApi.get(`/v2/themes`, {
        params: {
            paginate: false,
            company_id: company_id.value,
            only_visible: onlyVisible
        }
    });

    if (response.statusCode === 200 && response.data) {
        return response.data.map(item => parseItems(item));
    }

    return [];
}

function loadSources() {
    authApi.get(`/v2/sources?paginate=false&company_id=${company_id.value}`)
        .then( async (response) => {
            if (response.statusCode === 200) {
                if (Object.hasOwn(response, 'data')) {
                    response.data.forEach((item) => {
                        sources.value.push(parseItems(item))
                    })
                }
            }

        }).catch((error) => {
        showToast(error, 'Failed to load the Sources list');
    });
}

function applyFilter() {
    loadLearningOutcomes()
}

function clearFilter() {
    search.value.no_task = null
    search.value.no_debrief = null
    search.value.theme_id = null
    search.value.source_id = null
    search.value.details = null

    reloadTreeSelect.value += 1

    loadLearningOutcomes()
}

function onLearningOutcomeSaved() {
    closeLearningOutcomePopup()
    loadLearningOutcomes()
}

function deleteLearningOutcome(learningOutcomeId) {
    editingLearningOutcome.value = learningOutcomeId

    return authApi
        .delete(`/v2/learning-outcome/${learningOutcomeId}?companyId=${company_id.value}`)
        .then(() => {
            editingLearningOutcome.value = null
            const index = allLearningOutcomes.value.findIndex(item => item.id === learningOutcomeId)
            if (index > -1) { // only splice array when item is found
                allLearningOutcomes.value.splice(index, 1); // 2nd parameter means remove one item only
            }
        })
        .catch((error) => {
            editingLearningOutcome.value = null
            showToast(error, 'Failed to delete the LO');
        })
}

function editLearningOutcome(id) {
    console.log('editLearningOutcome', id)
    editingLearningOutcome.value = id
    showEditingLearningOutcome.value = true
    createUpdateLearningOutcomePopupTitle.value = 'Edit Learning Outcome'
}

function closeLearningOutcomePopup() {
    console.log('closing')
    editingLearningOutcome.value = null
    showEditingLearningOutcome.value = false
}

// Recursive function to parse incident types and property types
function parseItems(item) {
    let result = {}

    if (Object.hasOwn(item, 'id') && Object.hasOwn(item, 'name')) {
        result.id = item.id
        result.label = item.name

        if (Object.hasOwn(item, 'children') && item.children.length > 0) {
            result.children = []

            item.children.forEach((children) => {
                result.children.push(parseItems(children))
            })
        }
    }

    return result
}

</script>


<style scoped>
/*
    Override CSS to remove the unwanted border around the tree control
 */
.vue-treeselect {
    border: none !important;
}
.vue-treeselect__placeholder {
    color: rgb(0,0,0)  !important;
}
.vue-treeselect__single-value {
    color: rgb(0,0,0)  !important;
}
.vue-treeselect--focused.vue-treeselect--searchable .vue-treeselect__single-value {
    color: rgb(0,0,0)  !important;
}

</style>